import React from 'react';
import { Route } from 'react-router-dom';
import CardGrid from '../../GlobalSettings/CardsGrid.js';
import VersionChange from '../../GlobalSettings/GlobalSettingFiles/VersionChange.js';
import MetadataChange from '../../GlobalSettings/GlobalSettingFiles/MetadataChange.js';
import DisinfectionTimedata from '../../GlobalSettings/GlobalSettingFiles/DisinfectionTime.js';
import Imageaws from '../../GlobalSettings/GlobalSettingFiles/ImagesAWS.js';
import Viewimage from '../../GlobalSettings/GlobalSettingFiles/viewimage.js';

export const globalSettingsRoutes = [
  <Route key="card-global" path="/card-global" element={<CardGrid />} />,
  <Route key="update-version" path="/update-Version" element={<VersionChange />} />,
  <Route key="metadata-change" path="/metadata-Change" element={<MetadataChange />} />,
  <Route key="disinfection-time" path="/disinfectionTime" element={<DisinfectionTimedata />} />,
  <Route key="image-aws" path="/Imageaws" element={<Imageaws />} />,
  <Route key="view-image" path="/Viewimage" element={<Viewimage />} />,
];
